module.exports = __webpack_public_path__ + "static/media/as7.54e0ae61.png";